import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Row, Col } from 'antd';
import Animations from '../../animations/Animations';

class TwoVertSectionsView extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { leftChildren = null, rightChildren = null } = this.props;
        return (
            <motion.div
                style={{ width: "100%", height: "100%", overflow: "hidden" }}
                initial="initial"
                animate="animate"
                variants={Animations.STAGGER}
            >
                <Row type="flex" style={{ height: "100%" }}>
                    <Col flex="0 1 180px">
                        {leftChildren}
                    </Col>
                    <Col flex="1 1 300px">
                        {rightChildren}
                    </Col>
                </Row>
            </motion.div>
        );
    }
}

export default TwoVertSectionsView;